var _objectWithoutProperties = require("/builds/client-projects/fert-demolition-motos-website/application/node_modules/@babel/runtime/helpers/objectWithoutProperties.js").default;

var _objectSpread = require("/builds/client-projects/fert-demolition-motos-website/application/node_modules/@babel/runtime/helpers/objectSpread2.js").default;

var _slicedToArray = require("/builds/client-projects/fert-demolition-motos-website/application/node_modules/@babel/runtime/helpers/slicedToArray.js").default;

var _excluded = ["urlQueryArgs", "currentPostId"];
!function webpackUniversalModuleDefinition(e, r) {
  "object" == typeof exports && "object" == typeof module ? module.exports = r() : "function" == typeof define && define.amd ? define([], r) : "object" == typeof exports ? exports["@wordpress/server-side-render"] = r() : (e.wp = e.wp || {}, e.wp.serverSideRender = r());
}(self, function () {
  return function () {
    var e = {
      221: function _(e) {
        function _extends() {
          return e.exports = _extends = Object.assign || function (e) {
            for (var r = 1; r < arguments.length; r++) {
              var t = arguments[r];

              for (var s in t) {
                Object.prototype.hasOwnProperty.call(t, s) && (e[s] = t[s]);
              }
            }

            return e;
          }, e.exports.__esModule = !0, e.exports.default = e.exports, _extends.apply(this, arguments);
        }

        e.exports = _extends, e.exports.__esModule = !0, e.exports.default = e.exports;
      },
      424: function _(e) {
        e.exports = function _interopRequireDefault(e) {
          return e && e.__esModule ? e : {
            default: e
          };
        }, e.exports.__esModule = !0, e.exports.default = e.exports;
      },
      616: function _(e, r, t) {
        "use strict";

        var s = t(424);
        Object.defineProperty(r, "__esModule", {
          value: !0
        }), r.default = function ServerSideRender(e) {
          var r = e.attributes,
              t = e.block,
              s = e.className,
              _e$httpMethod = e.httpMethod,
              l = _e$httpMethod === void 0 ? "GET" : _e$httpMethod,
              i = e.urlQueryArgs,
              _e$EmptyResponsePlace = e.EmptyResponsePlaceholder,
              d = _e$EmptyResponsePlace === void 0 ? DefaultEmptyResponsePlaceholder : _e$EmptyResponsePlace,
              _e$ErrorResponsePlace = e.ErrorResponsePlaceholder,
              f = _e$ErrorResponsePlace === void 0 ? DefaultErrorResponsePlaceholder : _e$ErrorResponsePlace,
              _e$LoadingResponsePla = e.LoadingResponsePlaceholder,
              _ = _e$LoadingResponsePla === void 0 ? DefaultLoadingResponsePlaceholder : _e$LoadingResponsePla,
              w = (0, o.useRef)(!0),
              _ref = (0, o.useState)(!1),
              _ref2 = _slicedToArray(_ref, 2),
              m = _ref2[0],
              x = _ref2[1],
              h = (0, o.useRef)(),
              _ref3 = (0, o.useState)(null),
              _ref4 = _slicedToArray(_ref3, 2),
              v = _ref4[0],
              b = _ref4[1],
              E = (0, a.usePrevious)(e),
              _ref5 = (0, o.useState)(!1),
              _ref6 = _slicedToArray(_ref5, 2),
              P = _ref6[0],
              y = _ref6[1];

          function fetchData() {
            if (!w.current) return;
            y(!0);
            var e = r && (0, p.__experimentalSanitizeBlockAttributes)(t, r),
                s = "POST" === l,
                o = rendererPath(t, s ? null : null != e ? e : null, i),
                n = s ? {
              attributes: null != e ? e : null
            } : null,
                u = h.current = (0, c.default)({
              path: o,
              data: n,
              method: s ? "POST" : "GET"
            }).then(function (e) {
              w.current && u === h.current && e && b(e.rendered);
            }).catch(function (e) {
              w.current && u === h.current && b({
                error: !0,
                errorMsg: e.message
              });
            }).finally(function () {
              w.current && u === h.current && y(!1);
            });
            return u;
          }

          var q = (0, a.useDebounce)(fetchData, 500);
          (0, o.useEffect)(function () {
            return function () {
              w.current = !1;
            };
          }, []), (0, o.useEffect)(function () {
            void 0 === E ? fetchData() : (0, u.isEqual)(E, e) || q();
          }), (0, o.useEffect)(function () {
            if (!P) return;
            var e = setTimeout(function () {
              x(!0);
            }, 1e3);
            return function () {
              return clearTimeout(e);
            };
          }, [P]);
          var R = !!v,
              g = "" === v,
              S = null == v ? void 0 : v.error;
          if (P) return (0, o.createElement)(_, (0, n.default)({}, e, {
            showLoader: m
          }), R && (0, o.createElement)(o.RawHTML, {
            className: s
          }, v));
          if (g || !R) return (0, o.createElement)(d, e);
          if (S) return (0, o.createElement)(f, (0, n.default)({
            response: v
          }, e));
          return (0, o.createElement)(o.RawHTML, {
            className: s
          }, v);
        }, r.rendererPath = rendererPath;
        var o = t(753),
            n = s(t(221)),
            u = t(793),
            a = t(200),
            l = t(756),
            c = s(t(507)),
            i = t(904),
            d = t(892),
            p = t(700);

        function rendererPath(e) {
          var r = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : null,
              t = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
          return (0, i.addQueryArgs)("/wp/v2/block-renderer/".concat(e), _objectSpread(_objectSpread({
            context: "edit"
          }, null !== r ? {
            attributes: r
          } : {}), t));
        }

        function DefaultEmptyResponsePlaceholder(e) {
          var r = e.className;
          return (0, o.createElement)(d.Placeholder, {
            className: r
          }, (0, l.__)("Block rendered as empty."));
        }

        function DefaultErrorResponsePlaceholder(e) {
          var r = e.response,
              t = e.className;
          var s = (0, l.sprintf)((0, l.__)("Error loading block: %s"), r.errorMsg);
          return (0, o.createElement)(d.Placeholder, {
            className: t
          }, s);
        }

        function DefaultLoadingResponsePlaceholder(e) {
          var r = e.children,
              t = e.showLoader;
          return (0, o.createElement)("div", {
            style: {
              position: "relative"
            }
          }, t && (0, o.createElement)("div", {
            style: {
              position: "absolute",
              top: "50%",
              left: "50%",
              marginTop: "-9px",
              marginLeft: "-9px"
            }
          }, (0, o.createElement)(d.Spinner, null)), (0, o.createElement)("div", {
            style: {
              opacity: t ? "0.3" : 1
            }
          }, r));
        }
      },
      507: function _(e) {
        "use strict";

        e.exports = require("@wordpress/api-fetch");
      },
      700: function _(e) {
        "use strict";

        e.exports = require("@wordpress/blocks");
      },
      892: function _(e) {
        "use strict";

        e.exports = require("@wordpress/components");
      },
      200: function _(e) {
        "use strict";

        e.exports = require("@wordpress/compose");
      },
      467: function _(e) {
        "use strict";

        e.exports = require("@wordpress/data");
      },
      703: function _(e) {
        "use strict";

        e.exports = require("@wordpress/deprecated");
      },
      753: function _(e) {
        "use strict";

        e.exports = require("@wordpress/element");
      },
      756: function _(e) {
        "use strict";

        e.exports = require("@wordpress/i18n");
      },
      904: function _(e) {
        "use strict";

        e.exports = require("@wordpress/url");
      },
      793: function _(e) {
        "use strict";

        e.exports = require("lodash");
      }
    },
        r = {};

    function __webpack_require__(t) {
      var s = r[t];
      if (void 0 !== s) return s.exports;
      var o = r[t] = {
        exports: {}
      };
      return e[t](o, o.exports, __webpack_require__), o.exports;
    }

    var t = {};
    return function () {
      "use strict";

      var e = t,
          r = __webpack_require__(424);

      Object.defineProperty(e, "__esModule", {
        value: !0
      }), e.default = void 0;

      var s = __webpack_require__(753),
          o = r(__webpack_require__(221)),
          n = __webpack_require__(467),
          u = r(__webpack_require__(703)),
          a = r(__webpack_require__(616));

      var l = {},
          c = (0, n.withSelect)(function (e) {
        var r = e("core/editor");

        if (r) {
          var _e = r.getCurrentPostId();

          if (_e && "number" == typeof _e) return {
            currentPostId: _e
          };
        }

        return l;
      })(function (e) {
        var _e$urlQueryArgs = e.urlQueryArgs,
            r = _e$urlQueryArgs === void 0 ? l : _e$urlQueryArgs,
            t = e.currentPostId,
            n = _objectWithoutProperties(e, _excluded);

        var u = (0, s.useMemo)(function () {
          return t ? _objectSpread({
            post_id: t
          }, r) : r;
        }, [t, r]);
        return (0, s.createElement)(a.default, (0, o.default)({
          urlQueryArgs: u
        }, n));
      });
      window && window.wp && window.wp.components && (window.wp.components.ServerSideRender = (0, s.forwardRef)(function (e, r) {
        return (0, u.default)("wp.components.ServerSideRender", {
          since: "5.3",
          alternative: "wp.serverSideRender"
        }), (0, s.createElement)(c, (0, o.default)({}, e, {
          ref: r
        }));
      }));
      var i = c;
      e.default = i;
    }(), t;
  }();
});